/* --------------------------------------------------------------------------------------
   eipClient.js
   Copyright © 2023 Xerox Corporation. All Rights Reserved.
     
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
--------------------------------------------------------------------------------------*/

import { sessionVar } from "../../constants/storage.const";
import { getSessionVar } from "../../modules/browserStorage";
import { xrxReplaceChars } from "../modular-xerox-js-library/XRXXmlHandler.module";

export const deviceUrl = getSessionVar(sessionVar.deviceUrl)
export const deviceApiUrl = deviceUrl? deviceUrl : "https://127.0.0.1" 
export const axiosConfigForDevice = () => ({ headers: { "Content-Type": "text/xml" } })

export const xrxEscape = text => {
    text = unescape(text);
    text = xrxReplaceChars(text, "<", "&lt;");
    text = xrxReplaceChars(text, ">", "&gt;");
    return text;
}

export const xmlTag = (label, value, type) => type? `<${label} ${type}>${value}</${label}>` : `<${label}>${value}</${label}>`